import '@zillow/constellation-fonts/zillow-fonts.css';
import '../styles/globals.css';

import type { AppProps } from 'next/app';
import { Head } from '@zg-rentals/next/pages';
import { getCmsInfoForPage } from '@zillow/zrs-cms';
import { RpErrorBoundary, useBootstrap } from '@zg-rentals/rp-bootstrap-browser';
import { useEffectOnce } from 'react-use';
import { trackExposureEvent } from '../utils/trackExposureEvent';
import { emitPageEvent } from '../analytics/events';

const MyApp = ({ Component, pageProps }: AppProps) => {
  useBootstrap(() => import('../bootstrap/browser'));

  useEffectOnce(() => {
    emitPageEvent(getCmsInfoForPage(pageProps));
    trackExposureEvent();
  });

  return (
    <>
      <Head applicationName="zrm-marketing-web" buildRef={process.env.NEXT_PUBLIC_BUILD_REF}>
        {process.env.NEXT_PUBLIC_OPTIMIZELY_ID && (
          <>
            <link
              rel="preload"
              href="https://www.zillowstatic.com/s3/constellation-website/public/shared/fonts/object-sans/LATEST/object-sans-heavy.woff2"
              as="font"
              type="font/woff2"
              crossOrigin="anonymous"
            />
            <link
              rel="preload"
              href="https://www.zillowstatic.com/s3/constellation-website/public/shared/fonts/inter/LATEST/inter-variable.woff2"
              as="font"
              type="font/woff2"
              crossOrigin="anonymous"
            />
            <link
              rel="preload"
              href={`https://www.zillowstatic.com/optimizely/${process.env.NEXT_PUBLIC_OPTIMIZELY_ID}.js`}
              as="script"
            />
            <link rel="preconnect" href="//logx.optimizely.com" />
            <script src={`https://www.zillowstatic.com/optimizely/${process.env.NEXT_PUBLIC_OPTIMIZELY_ID}.js`} />
            <link
              rel="prefetch"
              href={`https://www.zillowstatic.com/optimizely/${process.env.NEXT_PUBLIC_OPTIMIZELY_ID}.js`}
              as="script"
            />
          </>
        )}
      </Head>

      <RpErrorBoundary>
        <Component {...pageProps} />
      </RpErrorBoundary>
    </>
  );
};

export default MyApp;
